<template>
  <facturatie />
</template>

<script>
import Facturatie from '../components/Raadplegen/Facturatie.vue'

export default {
  name: 'FacturatieView',
  components: {
    Facturatie
  }
}
</script>
